import { Category } from '../../lib/Category';

export const ASSIGNED_PRODUCTS_ID = Category.PRODUCTS;
